<template>
  <div class="AktuelleRunde" v-if="round != null && user">
    <h3>Aktuelle Runde</h3>

    <v-layout>
      <v-flex xs12 class="text-xs-center">
        <v-progress-circular indeterminate class="warning--text" v-if="loading" :width="7" :size="70"></v-progress-circular>
      </v-flex>
    </v-layout>

    <v-layout v-if="!loading">
      <v-flex xs12>
        <v-card>
          <v-card-title primary-title class="pt-2 pb-0">
            <h4 class="mb-1">{{ round.val().datum }}</h4>
          </v-card-title>
          
          <v-card-text class="pt-0">
            <h5 class="mb-1">Hcp {{myHcp}} | {{ round.val().farbe }}</h5>
            <table id="scoreTable">
              <thead>
                <tr>
                  <th>Loch-Nr</th>
                  <th>Par</th>
                  <th>Vorgabe</th>
                  <th>Punkte</th>
                  <th>Schläge</th>
                </tr>
              </thead>
              <tbody>
                <tr @click.stop="dialog = true, hole = 1">
                  <td>1</td>
                  <td>{{ myColorArray[0] }}</td>
                  <td>{{ myStablefordYellowSign[0] }}</td>
                  <td>{{ pointsOut[0] }}</td>
                  <td>
                    <b>{{ round.val().score1 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 2">
                  <td>2</td>
                  <td>{{ myColorArray[1] }}</td>
                  <td>{{ myStablefordYellowSign[1] }}</td>
                  <td>{{ pointsOut[1] }}</td>
                  <td>
                    <b>{{ round.val().score2 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 3">
                  <td>3</td>
                  <td>{{ myColorArray[2] }}</td>
                  <td>{{ myStablefordYellowSign[2] }}</td>
                  <td>{{ pointsOut[2] }}</td>
                  <td>
                    <b>{{ round.val().score3 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 4">
                  <td>4</td>
                  <td>{{ myColorArray[3] }}</td>
                  <td>{{ myStablefordYellowSign[3] }}</td>
                  <td>{{ pointsOut[3] }}</td>
                  <td>
                    <b>{{ round.val().score4 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 5">
                  <td>5</td>
                  <td>{{ myColorArray[4] }}</td>
                  <td>{{ myStablefordYellowSign[4] }}</td>
                  <td>{{ pointsOut[4] }}</td>
                  <td>
                    <b>{{ round.val().score5 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 6">
                  <td>6</td>
                  <td>{{ myColorArray[5] }}</td>
                  <td>{{ myStablefordYellowSign[5] }}</td>
                  <td>{{ pointsOut[5] }}</td>
                  <td>
                    <b>{{ round.val().score6 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 7">
                  <td>7</td>
                  <td>{{ myColorArray[6] }}</td>
                  <td>{{ myStablefordYellowSign[6] }}</td>
                  <td>{{ pointsOut[6] }}</td>
                  <td>
                    <b>{{ round.val().score7 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 8">
                  <td>8</td>
                  <td>{{ myColorArray[7] }}</td>
                  <td>{{ myStablefordYellowSign[7] }}</td>
                  <td>{{ pointsOut[7] }}</td>
                  <td>
                    <b>{{ round.val().score8 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 9">
                  <td>9</td>
                  <td>{{ myColorArray[8] }}</td>
                  <td>{{ myStablefordYellowSign[8] }}</td>
                  <td>{{ pointsOut[8] }}</td>
                  <td>
                    <b>{{ round.val().score9 }}</b>
                  </td>
                </tr>
                <tr style="height: 4em">
                  <td>
                    <strong>Score Out</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{ sumPointsOut }}</strong>
                  </td>
                  <td>
                    <strong>{{ scoreOut }}</strong>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 10">
                  <td>10</td>
                  <td>{{ myColorArray[9] }}</td>
                  <td>{{ myStablefordYellowSign[9] }}</td>
                  <td>{{ pointsOut[9] }}</td>
                  <td>
                    <b>{{ round.val().score10 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 11">
                  <td>11</td>
                  <td>{{ myColorArray[10] }}</td>
                  <td>{{ myStablefordYellowSign[10] }}</td>
                  <td>{{ pointsOut[10] }}</td>
                  <td>
                    <b>{{ round.val().score11 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 12">
                  <td>12</td>
                  <td>{{ myColorArray[11] }}</td>
                  <td>{{ myStablefordYellowSign[11] }}</td>
                  <td>{{ pointsOut[11] }}</td>
                  <td>
                    <b>{{ round.val().score12 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 13">
                  <td>13</td>
                  <td>{{ myColorArray[12] }}</td>
                  <td>{{ myStablefordYellowSign[12] }}</td>
                  <td>{{ pointsOut[12] }}</td>
                  <td>
                    <b>{{ round.val().score13 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 14">
                  <td>14</td>
                  <td>{{ myColorArray[13] }}</td>
                  <td>{{ myStablefordYellowSign[13] }}</td>
                  <td>{{ pointsOut[13] }}</td>
                  <td>
                    <b>{{ round.val().score14 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 15">
                  <td>15</td>
                  <td>{{ myColorArray[14] }}</td>
                  <td>{{ myStablefordYellowSign[14] }}</td>
                  <td>{{ pointsOut[14] }}</td>
                  <td>
                    <b>{{ round.val().score15 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 16">
                  <td>16</td>
                  <td>{{ myColorArray[15] }}</td>
                  <td>{{ myStablefordYellowSign[15] }}</td>
                  <td>{{ pointsOut[15] }}</td>
                  <td>
                    <b>{{ round.val().score16 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 17">
                  <td>17</td>
                  <td>{{ myColorArray[16] }}</td>
                  <td>{{ myStablefordYellowSign[16] }}</td>
                  <td>{{ pointsOut[16] }}</td>
                  <td>
                    <b>{{ round.val().score17 }}</b>
                  </td>
                </tr>
                <tr @click.stop="dialog = true, hole = 18">
                  <td>18</td>
                  <td>{{ myColorArray[17] }}</td>
                  <td>{{ myStablefordYellowSign[17] }}</td>
                  <td>{{ pointsOut[17] }}</td>
                  <td>
                    <b>{{ round.val().score18 }}</b>
                  </td>
                </tr>
                <tr style="height: 4em">
                  <td>
                    <strong>Score In</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{ sumPointsIn }}</strong>
                  </td>
                  <td>
                    <strong>{{ scoreIn }}</strong>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="border-top: 1px solid black">
                  <th>Gesamtscore</th>
                  <th></th>
                  <th></th>
                  <th>{{ points }}</th>
                  <th>{{ score }}</th>
                </tr>
              </tfoot>
            </table>
          </v-card-text>
          
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Modal -->
    <v-dialog v-model="dialog" lazy absolute>
      <v-card>
        <v-card-title>
          <div class="headline">Ergebnis Loch {{hole}}</div>
        </v-card-title>
        <v-card-text>
          Gewählter Score: <strong>{{number}}</strong>
          <v-layout row wrap>
            <v-flex xs4 v-for="i in options" :key="i">
              <v-btn light v-model="number" offset-xs1 class="mt-6 mr-0 ml-0 mb-6" @click="number = i">{{ i }}</v-btn>
            </v-flex>
            <v-flex xs4 offset-xs4>
              <v-btn light v-model="number" class="mt-6 mr-0 ml-0 mb-0" @click="number = '0'">0</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red--text darken-1" flat="flat" @click.native="dialog = false, hole = null">Abbrechen</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="setScore">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
export default {
  name: "AktuelleRunde",
  data() {
    return {
      yellowArray: [5, 4, 4, 4, 4, 3, 4, 4, 4, 4, 3, 4, 4, 4, 5, 3, 5, 5],
      stablefordYellow: [
        11,
        15,
        3,
        1,
        9,
        13,
        7,
        5,
        17,
        10,
        12,
        16,
        2,
        4,
        8,
        18,
        14,
        6
      ],
      dialog: false,
      options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      number: "0",
      hole: null
    };
    // End Data
  },

  computed: {
    user() {
      return this.$store.getters.user;
    },
    myHcp() {
      return this.$store.getters.myHcp;
    },
    year() {
      return this.$store.getters.year;
    },
    key() {
      return this.$store.getters.actualRoundKey;
    },
    loading() {
      return this.$store.getters.loading;
    },
    round() {
      return this.$store.getters.actualRound;
    },
    myColorArray() {
      if (this.round.val().farbe == "gelb") {
        return this.yellowArray;
      }
    },
    myStablefordYellow() {
      if (this.myHcp !== null && this.myHcp !== undefined) {
        const myStablefordCalc = this.myHcp * (130 / 113) - 73.1 + 73;
        const myStablefordRound = Math.round(myStablefordCalc);
        const spielvorgabe = Math.abs(myStablefordRound);
        const divident = spielvorgabe / 18;
        var yellowArray = [];
        // Hcp < 18
        if (divident <= 1) {
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q <= spielvorgabe) {
              yellowArray.push(1);
            } else {
              yellowArray.push(0);
            }
          }
        } else if (divident > 1 && divident <= 2) {
          // Hcp > 18 und <= 36
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q > spielvorgabe - 18) {
              yellowArray.push(1);
            } else {
              yellowArray.push(2);
            }
          }
        }
        return yellowArray;
      }
    },
    myStablefordYellowSign() {
      if (this.myHcp !== null && this.myHcp !== undefined) {
        const myStablefordCalc = this.myHcp * (130 / 113) - 73.1 + 73;
        const myStablefordRound = Math.round(myStablefordCalc);
        const spielvorgabe = Math.abs(myStablefordRound);
        const divident = spielvorgabe / 18;
        var yellowSignArray = [];
        // Hcp < 18
        if (divident <= 1) {
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q <= spielvorgabe) {
              yellowSignArray.push("/");
            } else {
              yellowSignArray.push("");
            }
          }
        } else if (divident > 1 && divident <= 2) {
          // Hcp > 18 und <= 36
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q > spielvorgabe - 18) {
              yellowSignArray.push("/");
            } else {
              yellowSignArray.push("//");
            }
          }
        }
        return yellowSignArray;
      }
    },
    scoreOut() {
      if (this.round !== null) {
        var score = 0;
        var x = this.round.val();
        score =
          x.score1 +
          x.score2 +
          x.score3 +
          x.score4 +
          x.score5 +
          x.score6 +
          x.score7 +
          x.score8 +
          x.score9;
      }
      return score;
    },
    scoreIn() {
      if (this.round !== null) {
        var score = 0;
        var x = this.round.val();
        score =
          x.score10 +
          x.score11 +
          x.score12 +
          x.score13 +
          x.score14 +
          x.score15 +
          x.score16 +
          x.score17 +
          x.score18;
      }
      return score;
    },
    score() {
      if (this.round !== null) {
        return this.scoreIn + this.scoreOut;
      }
    },
    pointsOut() {
      if (this.round !== null) {
        var pointsOut = [];
        const obj = this.round.val();
        for (var i = 1; i < 19; i++) {
          var x = "score" + i;
          if (obj[x] == 0) {
            pointsOut.push(0);
          } else {
            var pointOut =
              this.myColorArray[i - 1] +
              this.myStablefordYellow[i - 1] -
              obj[x];
            if (pointOut == 0) {
              pointsOut.push(2);
            } else if (pointOut == 1) {
              pointsOut.push(3);
            } else if (pointOut >= 2) {
              pointsOut.push(4);
            } else if (pointOut == -1) {
              pointsOut.push(1);
            } else {
              pointsOut.push(0);
            }
          }
        }
        return pointsOut;
      }
    },
    sumPointsOut() {
      if (this.round !== null) {
        var sum = 0;
        for (var i = 0; i < 9; i++) {
          sum = sum + this.pointsOut[i]
        }
        return sum;
      }
    },
    sumPointsIn() {
      if (this.round !== null) {
        var sum = 0;
        for (var i = 8; i < 18; i++) {
          sum = sum + this.pointsOut[i]
        }
        return sum;
      }
    },
    points() {
      if (this.round !== null) {
        return this.sumPointsOut + this.sumPointsIn;
      }
    }

    // End Computed
  },

  watch: {
    points() {
      this.updateShortround();
    }
  },

  methods: {
    setScore() {
      if (this.number != null) {
        this.$store.dispatch("editScore", {
          key: this.key,
          loch: "score" + this.hole,
          score: Number(this.number),
          shortKey: this.round.val().shortKey,
          sumScore: this.score,
          points: this.points
        });
        this.dialog = false;
        this.number = "0";
      }
    },
    updateShortround() {
      if (this.number != null) {
        this.$store.dispatch("updateShortround", {
          shortKey: this.round.val().shortKey,
          score: this.score,
          points: this.points
        });
      }
    }
    // End Methods
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 667px) {
  .container {
    padding: 5px;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

table > tbody > tr:nth-child(odd) {
  background-color: #f2f2f2;
}

td {
  max-width: 20%;
  width: 20%;
  text-align: center;
}

tr {
  height: 3em;
  border-bottom: 1px solid #d0d0d0;
}

.editRow:hover {
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// AktuelleRunde.vue?513f1829